import { Heading, HFlow, Icon, Modal, ModalBody, ModalFooter, Text, VFlow } from 'bold-ui'
import { FooterButton } from 'components/footer-button'
import React from 'react'

interface RemoveAtendimentoErrorModalProps {
  modalRemoveErrorOpen: boolean
  setModalRemoveErrorOpen: (arg: boolean) => void
}

export default function RemoveAtendimentoErrorModal(props: RemoveAtendimentoErrorModalProps) {
  const { modalRemoveErrorOpen, setModalRemoveErrorOpen } = props
  return (
    <Modal open={modalRemoveErrorOpen} onClose={() => setModalRemoveErrorOpen(false)} size='small'>
      <ModalBody>
        <VFlow>
          <Heading level={2}>
            <HFlow alignItems='center'>
              <Icon icon='exclamationTriangleOutline' size={3} fill='alert' />
              Atenção
            </HFlow>
          </Heading>
          <Text>
            O atendimento de vacinação não pôde ser excluído devido a uma instabilidade no servidor da RNDS que impede a
            conexão. Por favor, tente novamente mais tarde.
          </Text>
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <FooterButton kind='primary' onClick={() => setModalRemoveErrorOpen(false)} size='medium'>
            Ok
          </FooterButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
